var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup8078(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8078",
    "data-name": "Group 8078",
    transform: "translate(-227.23 -109.822)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3154",
    "data-name": "Ellipse 3154",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(227.23 109.822)",
    fill: "#f1f1f1",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_5",
    "data-name": "Layer 5",
    d: "M3,18V13.76a1,1,0,0,1,.29-.71l2.35-2.34h0l7-7h0L14.45,1.9a3,3,0,0,1,4.24,0L20.1,3.31a3,3,0,0,1,0,4.24L9,18.71a1,1,0,0,1-.71.29H4A1,1,0,0,1,3,18Zm4.78-6.61,2.83,2.83,5.58-5.58L13.36,5.81ZM15.9,3.27,14.78,4.39l2.83,2.83L18.73,6.1a1,1,0,0,0,0-1.41L17.31,3.27A1,1,0,0,0,15.9,3.27ZM5,17H7.83l1.36-1.36L6.36,12.81,5,14.17Z",
    transform: "translate(238.23 122.8)",
    fill: "#021c31",
    opacity: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8078);
export default __webpack_public_path__ + "static/media/Group8078.0b6c9d5e4484cb222828997b9b015ce1.svg";
export { ForwardRef as ReactComponent };